/* global am4core, am4charts,  am4themes_animated, am4lang_fr_FR, infoPageHelper, bocAmchart4, infoConfig, helpers */
/* eslint-disable camelcase */

if (typeof am4core !== 'undefined') {
    am4core.useTheme(am4themes_animated);
    if (typeof bocAmchart4 !== 'undefined') {
        am4core.useTheme(bocAmchart4.bocTheme);
    }
    am4core.options.commercialLicense = true;

    var infoPageAmCharts = {

        /**
         * viewsPieChart html id
         */
        viewsPieChartId: 'bocss-info__viewsPieChart',

        /**
         * deviceChart html id
         */
        deviceChartId: 'bocss-info__deviceChart',

        /**
         * viewsLineChart html id
         */
        viewsLineChartId: 'bocss-info__viewsChart',

        /**
         * viewsPieChart object
         */
        viewsPieChart: '',

        /**
         * deviceChart object
         */
        deviceChart: '',

        /**
         * viewsLineChart object
         */
        viewsLineChart: '',

        /**
         * X-axis of the line chart
         */
        dateAxis: '',

        /**
         * Labels for the charts
         */
        labels: '',

        /**
         * Using either light or dark theme
         */
        theme: '',

        /**
         * Create the charts
         * @returns {void}
         */
        createCharts: function () {
            this.viewsLineChart = am4core.create(this.viewsLineChartId, am4charts.XYChart);
            this.viewsPieChart = am4core.create(this.viewsPieChartId, am4charts.PieChart);
            this.deviceChart = am4core.create(this.deviceChartId, am4charts.XYChart);
        },

        /**
         * Loads the Line chart for historical analytical data
         * @param {string} dateMetricViews week|day
         * @returns {void}
         */
        loadLineChart: function (dateMetricViews) {
            this.viewsLineChart.fontSize = infoConfig.fontSize;

            var title = this.viewsLineChart.titles.create();
            this.dateAxis = this.viewsLineChart.xAxes.push(new am4charts.DateAxis());
            //Tooltip date formats
            this.dateAxis.tooltipDateFormat = this.labels['dateFormats']['ttDateFormat'];
            this.dateAxis.dateFormats.setKey("day", this.labels['dateFormats']['dayDateFormat']);
            this.dateAxis.periodChangeDateFormats.setKey("day", this.labels['dateFormats']['dayDateFormat']);
            this.dateAxis.dateFormats.setKey("month", this.labels['dateFormats']['monthDateFormat']);
            this.dateAxis.periodChangeDateFormats.setKey("month", "[bold]yyyy[/]");
            this.dateAxis.endLocation = 0.75;

            this.setupDateAxis(this.dateAxis);

            switch (dateMetricViews) {
                case 'month':
                    this.setupTitle(title, this.labels['viewsChart']['titleMonth']);
                    this.dateAxis.baseInterval = {
                        timeUnit: "month",
                        count: 1
                    };
                    this.dateAxis.adapter.add("getTooltipText", function (text) {
                        var chart = infoPageAmCharts.viewsLineChart;
                        var formatMonth = infoPageAmCharts.labels['dateFormats']['monthDateFormat'];
                        var formatDate = infoPageAmCharts.labels['dateFormats']['dayDateFormat'];
                        var date = chart.dateFormatter.parse(text, formatDate);
                        return chart.dateFormatter.format(date, formatMonth);
                    });
                    break;
                case 'week':
                    this.setupTitle(title, this.labels['viewsChart']['titleWeek']);
                    this.dateAxis.adapter.add("getTooltipText", function (text) {
                        var chart = infoPageAmCharts.viewsLineChart;
                        var format = infoPageAmCharts.labels['dateFormats']['dayDateFormat'];
                        var weekStart = chart.dateFormatter.parse(text, format);
                        var weekStartParsed = chart.dateFormatter.format(weekStart, format);
                        var weekEnd = infoPageHelper.getWeek(weekStart);
                        var weekEndParsed = chart.dateFormatter.format(chart.dateFormatter.parse(weekEnd), format);
                        text = weekStartParsed + " - " + weekEndParsed;
                        if (infoPageHelper.isFrench()) {
                            text = infoPageHelper.updateFirstDayFrench(text);
                        }
                        return text;
                    });
                    break;
                case 'day':
                default:
                    this.setupTitle(title, this.labels['viewsChart']['titleDay']);
                    this.dateAxis.adapter.add("getTooltipText", function (text) {
                        if (infoPageHelper.isFrench()) {
                            text = infoPageHelper.updateFirstDayFrench(text);
                        }
                        return text;
                    });
            }

            var valueAxis = this.viewsLineChart.yAxes.push(new am4charts.ValueAxis());
            valueAxis.renderer.minWidth = 35;
            valueAxis.renderer.minGridDistance = 40;
            valueAxis.renderer.axisFills.template.disabled = true;
            valueAxis.renderer.ticks.template.disabled = true;
            this.setupValueAxis(valueAxis);

            var series = this.viewsLineChart.series.push(new am4charts.LineSeries());
            series.dataFields.dateX = "date";
            series.dataFields.valueY = "views";
            series.strokeWidth = 2;
            series.tensionX = 0.95;
            series.tooltipText = "{valueY} " + this.labels['viewsChart']['textViews'];
            this.setupSeriesTooltip(series);

            // disable init animation
            series.showOnInit = false;

            // cursor settings
            this.viewsLineChart.cursor = new am4charts.XYCursor();
            this.viewsLineChart.cursor.snapToSeries = series;
            this.viewsLineChart.cursor.lineY.disabled = true;
            this.viewsLineChart.cursor.behavior = "zoomX";

            // zoom out button settings
            this.viewsLineChart.zoomOutButton.icon.disabled = true;
            this.viewsLineChart.zoomOutButton.background.defaultState.properties.fill = this.getColor('magIconBgFill');
            this.viewsLineChart.zoomOutButton.background.states.getKey("hover").properties.fill = am4core.color("#636363");
            this.viewsLineChart.zoomOutButton.background.states.getKey("down").properties.fill = am4core.color("#636363");
            var zoomImage = this.viewsLineChart.zoomOutButton.createChild(am4core.Image);
            zoomImage.href = infoConfig["themes"][infoPageAmCharts.theme]['magIconHover'];
            zoomImage.height = 15;
            zoomImage.width = 15;
            //Don't interfere with the hover
            zoomImage.interactionsEnabled = false;

            //Change the magnify glass depending on hover
            this.viewsLineChart.zoomOutButton.events.on("over", function () {
                zoomImage.href = infoConfig["themes"][infoPageAmCharts.theme]['magIcon'];
            });
            this.viewsLineChart.zoomOutButton.events.on("out", function () {
                zoomImage.href = infoConfig["themes"][infoPageAmCharts.theme]['magIconHover'];
            });

            // scrollbar
            this.viewsLineChart.scrollbarX = new am4core.Scrollbar();
            this.viewsLineChart.scrollbarX.parent = this.viewsLineChart.bottomAxesContainer;
            this.viewsLineChart.scrollbarX.background.fill = this.getColor('scrollBackground');
            this.viewsLineChart.scrollbarX.background.fillOpacity = 0.5;
            this.viewsLineChart.scrollbarX.thumb.background.fill = this.getColor('gripBackground');
            this.viewsLineChart.scrollbarX.startGrip.background.fill = this.getColor('gripBackground');
            this.viewsLineChart.scrollbarX.endGrip.background.fill = this.getColor('gripBackground');

            // Fires updates after chart data is is ready to be drawn - this happens only on load
            this.viewsLineChart.events.on("ready", function () {
                infoPageAmCharts.zoomToDates(dateMetricViews);
            });
        },

        /**
         * Loads the Pie chart for total views over a period
         * @returns {void}
         */
        loadPieChart: function () {
            this.viewsPieChart.data = [
                {
                    "value": 0
                },
                {
                    "value": 0,
                    "config": {
                        "fill": "#EEE",
                        "stroke": "#EEE"
                    }
                }
            ];

            // Set inner radius
            this.viewsPieChart.innerRadius = am4core.percent(90);

            // Add and configure Series
            var pieSeries = this.viewsPieChart.series.push(new am4charts.PieSeries());
            pieSeries.dataFields.value = "value";

            pieSeries.slices.template.configField = "config";
            pieSeries.slices.template.states.getKey("hover").properties.scale = 1;
            pieSeries.slices.template.states.getKey("active").properties.shiftRadius = 0;
            pieSeries.slices.template.tooltipText = "";

            pieSeries.labels.template.disabled = true;
            // disable init animation
            pieSeries.showOnInit = false;
            // This creates initial animation
            pieSeries.hiddenState.properties.opacity = 1;
            pieSeries.hiddenState.properties.endAngle = -90;
            pieSeries.hiddenState.properties.startAngle = -90;

            // Fires updates after chart data is validated - this happens only on load
            this.viewsPieChart.events.on("datavalidated", function () {
                infoPageAmCharts.updateViewsPieChart();
            });

            this.dateAxis.events.on("startendchanged", helpers.debounce(infoPageAmCharts.updateViewsPieChart, 5));
            this.dateAxis.events.on("ready", helpers.debounce(infoPageAmCharts.updateViewsPieChart, 5));
        },

        /**
         * Loads the device pie chart
         * @param {string} dateMetricDevices month|year
         * @returns {void} void
         */
        loadDeviceChart: function (dateMetricDevices) {
            this.deviceChart.fontSize = infoConfig.fontSize;
            this.deviceChart.responsive.enabled = false;

            var dateAxis = this.deviceChart.xAxes.push(new am4charts.DateAxis());
            this.setupDateAxis(dateAxis);

            switch (dateMetricDevices) {
                case 'month':
                    dateAxis.dateFormats.setKey("month", this.labels["dateFormats"]["monthDateFormat"]);
                    dateAxis.baseInterval = {
                        timeUnit: "month",
                        count: 1
                    };
                    dateAxis.renderer.minGridDistance = 50;
                    break;
                case 'year':
                default:
                    dateAxis.dateFormats.setKey("year", this.labels["dateFormats"]["yearFormat"]);
                    dateAxis.baseInterval = {
                        timeUnit: "year",
                        count: 1
                    };
                    dateAxis.baseInterval.timeUnit = 'year';
                    dateAxis.renderer.minGridDistance = 30;
            }

            var title = this.deviceChart.titles.create();
            this.setupTitle(title, this.labels["deviceChart"]["titleText"]);

            // Create axes
            var valueAxis = this.deviceChart.yAxes.push(new am4charts.ValueAxis());
            valueAxis.calculateTotals = true;
            valueAxis.max = 100;
            valueAxis.strictMinMax = true;
            valueAxis.renderer.labels.template.adapter.add("text", function (text) {
                return text + infoPageAmCharts.labels['percent'];
            });
            this.setupValueAxis(valueAxis);

            // Create series
            var names = this.labels["deviceChart"]["names"];
            this.deviceChart.series.push(infoPageAmCharts.createDeviceSeries(names[0], "desktop"));
            this.deviceChart.series.push(infoPageAmCharts.createDeviceSeries(names[1], "mobile"));
            this.deviceChart.series.push(infoPageAmCharts.createDeviceSeries(names[2], "tablet"));

            // Create legend
            var legendContainer = am4core.create("bocss-info__deviceLegend", am4core.Container);
            legendContainer.width = am4core.percent(100);
            legendContainer.fontSize = infoConfig.fontSize;

            this.deviceChart.legend = new am4charts.Legend();
            this.deviceChart.legend.parent = legendContainer;
            this.deviceChart.legend.interactionsEnabled = false;
            this.deviceChart.legend.useDefaultMarker = true;
            this.deviceChart.legend.labels.template.fill = this.getColor("font");

            var marker = this.deviceChart.legend.markers.template.children.getIndex(0);
            marker.cornerRadius(12, 12, 12, 12);
            marker.fillOpacity = 0.5;
            marker.strokeWidth = 1;
            marker.strokeOpacity = 1;
            marker.height = 18;
            marker.width = 18;

            //set the outside border darker
            marker.adapter.add("stroke", function (stroke, target) {
                if (target.properties.fill) {
                    stroke = am4core.color(target.properties.fill.hex);
                }
                return stroke;
            });

            this.deviceChart.legend.events.on("datavalidated", infoPageHelper.resizeLegend);
            this.deviceChart.legend.events.on("maxsizechanged", infoPageHelper.resizeLegend);

            // Add cursor
            this.deviceChart.cursor = new am4charts.XYCursor();
            this.deviceChart.cursor.lineY.disabled = true;
            this.deviceChart.cursor.behavior = "none";

            // Fires updates after chart data is validated - this happens only on load
            this.deviceChart.events.on("datavalidated", infoPageHelper.resizeLegend);
            this.deviceChart.events.on("maxsizechanged", infoPageHelper.resizeLegend);
        },

        /**
         * Updates the views pie chart based on the graph's scroll bar zoom
         * @returns {void}
         */
        updateViewsPieChart: function () {
            //shorten up the variable names, to reduce redundancy
            var lineChart = infoPageAmCharts.viewsLineChart;
            var pieChart = infoPageAmCharts.viewsPieChart;
            var dateAxis = infoPageAmCharts.dateAxis;
            var dateformat = infoPageAmCharts.labels['dateFormats']['ttDateFormat'];

            // check that there is views data
            if (lineChart.data.length > 0) {
                // get start and end dates from scrollbar range
                var start = new Date(dateAxis.minZoomed);
                var end = new Date(dateAxis.maxZoomed);

                // Using yesterday date as the maximum possible
                var max = new Date();
                max.setDate(max.getDate() - 1);

                // check if end date exceeds range
                if (end > max) {
                    end = max;
                }
                // display start and end dates
                var startDateFull = lineChart.dateFormatter.format(start, dateformat);
                var endDateFull = lineChart.dateFormatter.format(end, dateformat);
                infoPageHelper.updateDateRange(startDateFull, endDateFull);

                // formats dates to yyyy-mm-dd format
                var fStart = lineChart.dateFormatter.format(start);
                var fEnd = lineChart.dateFormatter.format(end);
                // get number of views between date range
                var rangeTotalViews = 0;

                lineChart.data.forEach(function (data) {
                    if (lineChart.dateFormatter.format(data.date) >= fStart
                        && lineChart.dateFormatter.format(data.date) <= fEnd) {
                        rangeTotalViews += data.views;
                    }
                });

                // update pie chart
                pieChart.data[0].value = rangeTotalViews;
                pieChart.data[1].value = lineChart.allTimeViews - rangeTotalViews;
                pieChart.invalidateRawData();

                // display total views within chart range
                infoPageHelper.updateRangeViews(rangeTotalViews);
            }
        },

        /**
         * Zooms chart to a specific date range
         * @param {string} dateMetricViews day|week
         * @returns {void}
         */
        zoomToDates: function (dateMetricViews) {
            var zoomDays = 150;
            var periods;
            switch (dateMetricViews) {
                case 'week':
                    periods = zoomDays / 7;
                    break;
                case 'month':
                    // Increase zoom to 9 months for monthly data
                    zoomDays = 9 * 30;
                    periods = zoomDays / 30;
                    break;
                case 'day':
                default:
                    periods = zoomDays;
            }
            // check that there are at least 5 years days of data
            // if (this.viewsLineChart.data.length > zoomDays / 30) {
            if (this.viewsLineChart.data.length > periods) {
                // zoom chart to show last 5 years of data
                var startDate = new Date();
                startDate.setDate(startDate.getDate() - zoomDays);
                this.dateAxis.zoomToDates(startDate, new Date(), false, true);
            }
        },

        /**
         * Sets the options for a stacked series
         * @param {string} name Name of the series
         * @param {string} value Name of the series value
         *
         * @returns {series} am4Charts series
         */
        createDeviceSeries: function (name, value) {
            var series = new am4charts.ColumnSeries();
            series.dataFields.valueY = value;
            series.dataFields.valueYShow = "totalPercent";
            series.dataFields.dateX = "date";
            series.name = name;
            series.tooltipText =
                "{name}: {valueY} ({valueY.totalPercent.formatNumber('#.00')}" + this.labels['percent'] + ")";
            series.fillOpacity = 0.5;
            series.strokeWidth = 1;
            series.stacked = true;
            this.setupSeriesTooltip(series);
            return series;
        },

        /**
         * Setup the value axis parameters
         * @param {object} valueAxis The value axis object
         * @returns {void}
         */
        setupValueAxis: function (valueAxis) {
            valueAxis.tooltip.disabled = true;
            valueAxis.min = 0;
            valueAxis.renderer.grid.template.stroke = this.getColor("font");
            valueAxis.renderer.grid.template.opacity = 0.5;
            valueAxis.renderer.labels.template.fill = this.getColor("font");
        },

        /**
         * Setup the series Tooltip parameters
         * @param {object} series Chart series object
         * @returns {void}
         */
        setupSeriesTooltip: function (series) {
            series.tooltip.getFillFromObject = false;
            series.tooltip.getStrokeFromObject = true;
            series.tooltip.label.fill = this.getColor("font");
            series.tooltip.background.strokeWidth = infoConfig.tooltipSeriesStrokeWidth;
            series.tooltip.background.fillOpacity = 0.8;
            series.tooltip.background.fill = this.getColor("tooltipSeriesFill");
            series.tooltip.label.fontSize = infoConfig.tooltipFontSize;
        },

        /**
         * Set the chart title parameters
         * @param {object} title Chart tile object
         * @param {string} titleText Title text
         * @returns {void}
         */
        setupTitle: function (title, titleText) {
            title.text = titleText;
            title.fontSize = infoConfig.titleFontSize;
            title.fontWeight = "bold";
            title.fill = this.getColor("font");
            title.marginBottom = 20;
        },

        /**
         * Setup the dateAxis parameters
         * @param {object} dateAxis the chart axis
         * @returns {void}
         */
        setupDateAxis: function (dateAxis) {
            dateAxis.tooltip.background.strokeWidth = infoConfig.tooltipDateAxisStrokeWidth;
            dateAxis.tooltip.background.pointerLength = 0;
            dateAxis.tooltip.background.fill = this.getColor("tooltipDateFill");
            dateAxis.tooltip.dy = 5;
            dateAxis.tooltip.label.fill = this.getColor("tooltipDateFont");
            dateAxis.tooltip.label.fontSize = infoConfig.tooltipFontSize;
            dateAxis.renderer.grid.template.location = 0;
            dateAxis.renderer.axisFills.template.disabled = true;
            dateAxis.renderer.ticks.template.disabled = true;
            dateAxis.renderer.grid.template.stroke = this.getColor("font");
            dateAxis.renderer.grid.template.opacity = 0.5;
            dateAxis.renderer.labels.template.fill = this.getColor("font");
            dateAxis.renderer.minGridDistance = 80;
        },

        /**
         * Setup the label and chart translations in French
         * @return {void}
         */
        setupLanguages: function () {
            if (infoPageHelper.isFrench()) {
                this.viewsLineChart.language.locale = am4lang_fr_FR;
                this.deviceChart.language.locale = am4lang_fr_FR;
                this.labels = infoConfig.labelsFr;
            } else {
                this.labels = infoConfig.labelsEn;
            }
        },

        /**
         * Set which theme to use
         * @return {void}
         */
        setupTheme: function () {
            if (infoPageHelper.isDarkTheme()) {
                this.theme = "dark";
            } else {
                this.theme = "light";
            }
        },

        /**
         * Get a color for
         * @param {string} variable The name of the color variable
         * @returns {object} amcharts color object
         */
        getColor: function (variable) {
            return am4core.color(infoConfig.themes[this.theme][variable]);
        }
    };
}
